import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PageModelData } from '@/types/index';
import { AbstractModelImpl } from '@/services/common/abstract-model';

export const PageModel = Symbol('PageModel');

export interface PageModel extends AbstractModelImpl<PageModelData> {
    get modelData(): PageModelData;
    update(getUpdateValue: (value: PageModelData) => PageModelData): void;
    reset(): void;
}

@injectable()
export class PageModelImpl extends AbstractModelImpl<PageModelData> implements PageModel {
    _defaultModelData: PageModelData = {
        title: '',
        fmea_id: '',
        stage: 0,
        generate_status: undefined,
        show_grid_toolbar: false,
        is_downloading: false,
    };

    _modelData: PageModelData = this._defaultModelData;

    reset() {
        this._modelData = this._defaultModelData;
    }

    constructor(
    ) {
        super();
    }
}
